import React from "react";
import Header from "../components/nextgadget/header";
import Footer from "../components/nextgadget/footer";
import AppRoutes from "../routes";
import HomePage from "../pages/nextgadget/home_page";
import AboutPage from "../pages/nextgadget/about_page";
import ContactPage from "../pages/nextgadget/contact_page";

const NextgadgetTemplate = () => {
  return (
    <div className="px-10">
      <Header />
      <AppRoutes
        homePage={HomePage}
        aboutPage={AboutPage}
        contactPage={ContactPage}
      />
      <Footer />
    </div>
  );
};

export default NextgadgetTemplate;
